import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  positionGroup: [],
  filterCompany: [],
  filterUom: [],
  loadingStates: []
}

const fetchUomStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchUomSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_code: data?.company?.company_code
    }
  })
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: action.pagination,
    records
  }
}

const fetchUomFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    errorMessage: action.errorMessage
  }
}

const fetchUomByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedUomRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createUomStart = (state, action) => {
  return { ...state, loading: true }
}

const createUomSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createUomFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateUomStart = (state, action) => {
  return { ...state, loading: true }
}

const updateUomSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateUomFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteUomStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteUomSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteUomFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchUomFilterCompanyStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchUomFilterCompanySuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterCompany: action.data
  }
}

const fetchUomFilterCompanyFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchUomFilterUomStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchUomFilterUomSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    filterUom: action.data
  }
}

const fetchUomFilterUomFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_UOM_START:
      return fetchUomStart(state, action)
    case actionTypes.FETCH_UOM_SUCCESS:
      return fetchUomSuccess(state, action)
    case actionTypes.FETCH_UOM_BY_ID_SUCCESS:
      return fetchUomByIdSuccess(state, action)
    case actionTypes.FETCH_UOM_FAILED:
      return fetchUomFailed(state, action)
    case actionTypes.CLEAR_SELECTED_UOM_RECORD:
      return clearSelectedUomRecord(state, action)
    case actionTypes.CREATE_UOM_START:
      return createUomStart(state, action)
    case actionTypes.CREATE_UOM_SUCCESS:
      return createUomSuccess(state, action)
    case actionTypes.CREATE_UOM_FAILED:
      return createUomFailed(state, action)
    case actionTypes.UPDATE_UOM_START:
      return updateUomStart(state, action)
    case actionTypes.UPDATE_UOM_SUCCESS:
      return updateUomSuccess(state, action)
    case actionTypes.UPDATE_UOM_FAILED:
      return updateUomFailed(state, action)
    case actionTypes.DELETE_UOM_START:
      return deleteUomStart(state, action)
    case actionTypes.DELETE_UOM_SUCCESS:
      return deleteUomSuccess(state, action)
    case actionTypes.DELETE_UOM_FAILED:
      return deleteUomFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_UOM_FILTER_COMPANY_START:
      return fetchUomFilterCompanyStart(state, action)
    case actionTypes.FETCH_UOM_FILTER_COMPANY_SUCCESS:
      return fetchUomFilterCompanySuccess(state, action)
    case actionTypes.FETCH_UOM_FILTER_COMPANY_FAILED:
      return fetchUomFilterCompanyFailed(state, action)
    case actionTypes.FETCH_UOM_FILTER_UOM_START:
      return fetchUomFilterUomStart(state, action)
    case actionTypes.FETCH_UOM_FILTER_UOM_SUCCESS:
      return fetchUomFilterUomSuccess(state, action)
    case actionTypes.FETCH_UOM_FILTER_UOM_FAILED:
      return fetchUomFilterUomFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
